<template>
  <div class="d-flex flex-column">
    <v-card>
      <div class="ma-2 pt-2">
        <v-row no-gutters class="d-flex align-center">
          <v-col cols="8" xl="3" lg="4" md="4" sm="5">
            <v-select
              class="pr-2"
              v-model="search"
              :items="uniqueGames"
              :loading="loading"
              :label="$t('game')"
              single-line
              item-text="name_game"
              dense
              hide-details
              :no-data-text="$t('noDataFound')"
              solo-inverted
              clearable
            >
              <template v-slot:item="{ item }">
                <v-list-item-avatar class="colorDominant">
                  <v-img
                    v-if="item.imageError === false"
                    :src="item.src"
                    @error="item.imageError = true"
                  ></v-img>
                  <v-icon v-else size="32">
                    mdi-image
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.name_game"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-text="item.provider"
                  ></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-select>
          </v-col>

          <v-spacer />

          <v-col
            cols="3"
            class="d-flex flex-row-reverse d-md-none d-lg-none d-xl-none"
          >
            <div>
              <v-btn-toggle dense>
                <v-btn @click="breakpoint = 0" ref="desktopBreakpoint">
                  <v-icon>mdi-view-list</v-icon>
                </v-btn>

                <v-btn @click="breakpoint = 'xs'" ref="mobileBreakpoint">
                  <v-icon>mdi-view-grid</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
          </v-col>
        </v-row>
      </div>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :loading="loading"
        :loading-text="$t('casinoBetting.loadingBets')"
        :no-data-text="$t('nullData')"
        :items-per-page="10"
        :mobile-breakpoint="breakpoint"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
        :disable-sort="$vuetify.breakpoint.mobile"
        :class="breakpoint === 'xs' ? 'gridTable' : ''"
      >
        <template v-slot:body="{ items, headers }">
          <tbody
            name="list"
            is="transition-group"
            v-if="items.length > 0 && breakpoint !== 'xs'"
          >
            <tr v-for="(item, k) in items" :key="k" class="item-row">
              <td>
                {{
                  new Date(
                    item.date_register.replace(" ", "T")
                  ).toLocaleTimeString([], {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                }}
              </td>
              <td>
                <v-img
                  v-if="item.imageError === false"
                  class="ma-2"
                  :src="item.src"
                  width="62"
                  height="62"
                  style="border-radius: 8px; cursor: pointer;"
                  @error="item.imageError = true"
                  @click.stop="cardClick(item)"
                />

                <v-icon v-else size="62" class="ma-2">
                  mdi-image
                </v-icon>
              </td>

              <td>
                {{ item.name_game }}
              </td>

              <td>
                ID: {{ item.entry_id }}
                <v-icon small @click="$copy(item.entry_id)">
                  mdi-content-copy
                </v-icon>
              </td>
              <td>
                <div v-if="item.round_id">
                  ID: {{ item.round_id }}
                  <v-icon small @click="$copy(item.round_id)">
                    mdi-content-copy
                  </v-icon>
                </div>
              </td>
              <td>
                {{
                  mapOperationIdToOperationName({
                    operation_id: item.operation_id,
                  })
                }}
              </td>
              <td :class="{ 'green--text': item.operation_id === '102' }">
                {{ item.amount }}
              </td>
            </tr>
          </tbody>

          <tbody name="list" is="transition-group" v-else-if="items.length > 0">
            <tr
              v-for="(item, index) in items"
              :key="index"
              class="item-row casino-item"
            >
              <v-card
                class="pa-4 mb-2"
                :class="{
                  'mt-2': index === 0,
                }"
              >
                <div class="d-flex justify-space-between" style="gap: 10px;">
                  <img
                    v-if="item.imageError === false"
                    :src="item.src"
                    width="62"
                    height="62"
                    style="border-radius: 8px; cursor: pointer;"
                    @error="item.imageError = true"
                    @click.stop="cardClick(item)"
                  />

                  <v-icon v-else size="32">
                    mdi-image
                  </v-icon>

                  <div class="d-flex flex-column">
                    <div
                      :style="
                        `font-size: ${
                          $vuetify.breakpoint.width > 400 ? 90 : 80
                        }%`
                      "
                    >
                      {{ item.name_game }}
                    </div>
                    <div
                      :style="
                        `font-size: ${
                          $vuetify.breakpoint.width > 400 ? 80 : 70
                        }%`
                      "
                    >
                      {{ $t("casinoBetting.headers.transactionId") }}:
                      {{ item.entry_id }}
                      <v-icon
                        :x-small="$vuetify.breakpoint.width <= 400"
                        :small="$vuetify.breakpoint.width > 400"
                        @click="$copy(item.entry_id)"
                      >
                        mdi-content-copy
                      </v-icon>
                    </div>
                    <div
                      :style="
                        `font-size: ${
                          $vuetify.breakpoint.width > 400 ? 80 : 70
                        }%`
                      "
                      v-if="item.round_id"
                    >
                      {{ $t("casinoBetting.headers.roundId") }}:
                      {{ item.round_id }}
                      <v-icon
                        :x-small="$vuetify.breakpoint.width <= 400"
                        :small="$vuetify.breakpoint.width > 400"
                        @click="$copy(item.round_id)"
                      >
                        mdi-content-copy
                      </v-icon>
                    </div>
                  </div>
                  <div class="d-flex flex-column align-end">
                    <small style="color: #84999F;">
                      {{
                        new Date(
                          item.date_register.replace(" ", "T")
                        ).toLocaleDateString([], {
                          year: "numeric",
                          month: "numeric",
                          day: "numeric",
                        })
                      }}
                    </small>

                    <small style="color: #84999F;">
                      {{
                        new Date(
                          item.date_register.replace(" ", "T")
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      }}
                    </small>
                  </div>
                </div>

                <div class="pt-4 text-body-2">
                  <div class="d-flex justify-space-between mb-1">
                    <div>
                      {{ $t("value") }}
                    </div>
                    <div
                      :class="{ 'green--text': item.operation_id === '102' }"
                    >
                      {{ item.amount }}
                    </div>
                  </div>

                  <div class="d-flex justify-space-between">
                    <div>
                      {{ $t("type") }}
                    </div>
                    <div>
                      {{
                        mapOperationIdToOperationName({
                          operation_id: item.operation_id,
                        })
                      }}
                    </div>
                  </div>
                </div>
              </v-card>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>

    <div
      class="mt-2 d-flex align-self-end"
      :style="
        $vuetify.breakpoint.smAndDown ? 'width: 100%' : 'min-width: 350px'
      "
      v-if="items.length > 0"
    >
      <v-card class="d-flex flex-column pa-3" style="width: 100%">
        <span> {{ $t("periodSummaryTitle") }} {{ gameOrAllGames }} </span>

        <div class="d-flex align-center mb-3">
          <v-icon small class="mr-1">
            mdi-calendar
          </v-icon>

          <span style="color: #D9D9D9; font-size: 80%;">
            {{ searchedPeriod }}
          </span>
        </div>

        <div
          v-for="(_, key) in resume"
          :key="key"
          class="d-flex justify-space-between text-subtitle-2 mt-2"
        >
          <div>
            {{ $t(`casinoBetting.${key}`) }}
          </div>
          <div
            :class="{
              'green--text lighten-1':
                key === 'profit' && Number(resume[key]) > 0,
              'red--text lighten-1':
                key === 'profit' && Number(resume[key]) < 0,
            }"
          >
            {{ getPortugueseMoney(resume[key]) }}
          </div>
        </div>
      </v-card>
    </div>

    <ItemDialog
      :dialog="itemDialog"
      type="lobby"
      :categoryName="currentGameDialog ? currentGameDialog.categoryName : ''"
      :item="currentGameDialog"
      @closeItemDialog="closeItemDialog"
    />
  </div>
</template>

<script>
import ItemDialog from "@/views/home/casinoNew/components/item/itemDialog";

export default {
  data: () => ({
    items: [],
    loading: false,
    search: "",
    breakpoint: "",
    searchedPeriod: "",
    resume: {},
    currentGame: "",
    // Dialog Game
    currentGameDialog: {},
    itemDialog: false,
  }),

  components: { ItemDialog },

  created() {
    this.$nextTick(() => {
      const ref = this.$vuetify.breakpoint.mobile
        ? "mobileBreakpoint"
        : "desktopBreakpoint";

      this.$refs[ref].$el.click();
    });

    this.$store.commit("setCasinoCustomRange", { to: "", from: "" });
  },

  destroyed() {
    this.$store.commit("setCasinoBetsStatus", []);
  },

  watch: {
    search(val) {
      this.currentGame = val;

      if (val) {
        const game = this.items.find(({ name_game }) => name_game === val);
        this.buildResume(game.name_game);
      } else {
        this.buildResume();
      }
    },
    saveFilters(val) {
      val && this.fetchCasinoBets();
    },
  },

  computed: {
    gameOrAllGames() {
      if (this.currentGame && this.currentGame.length > 0) {
        return `(${this.currentGame})`;
      }

      return `(${this.$t("casinoBetting.allGames")})`;
    },
    uniqueGames() {
      const unique = [];

      this.items.forEach((game) => {
        if (!unique.find(({ name_game }) => name_game === game.name_game)) {
          unique.push(game);
        }
      });

      return unique;
    },
    headers() {
      return [
        {
          text: this.$t("casinoBetting.headers.dateAndHour"),
          value: "date_register",
        },
        { text: "Logo", value: "src" },
        { text: this.$t("game"), value: "name_game" },
        {
          text: this.$t("casinoBetting.headers.transactionId"),
          value: "entry_id",
        },
        { text: this.$t("casinoBetting.headers.roundId"), value: "round_id" },
        { text: this.$t("type"), value: "operation_id" },
        { text: this.$t("value"), value: "amount" },
      ];
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },

  methods: {
    fetchCasinoBets() {
      const body = {};

      this.currentGame = null;
      this.search = "";

      const { value, customRange } = this.$store.state.filters.casinoRange;

      if (value === "customRange") {
        if (!customRange || !customRange.to || !customRange.from) {
          this.setDateIntervalAlert();
          return;
        }

        const { from, to } = customRange;
        body.date_start = this.formatBrazilianDate(from) + " 00:00:00";
        body.date_final = this.formatBrazilianDate(to) + " 23:59:59";
      } else {
        const mapValuesToDays = {
          last24Hours: 1,
          last48Hours: 2,
          last7Days: 7,
        };

        const { date_start, date_final } = this.getDateRange({
          daysAgo: mapValuesToDays[value],
        });

        body.date_start = date_start.slice(0, date_start.length - 1);
        body.date_final = date_final.slice(0, date_final.length - 1);
      }

      this.items = [];
      this.loading = true;

      const { selected } = this.$store.state.filters.casinoBetsStatus;
      const withoutAll = selected.filter((option) => option.value !== "all");
      if (withoutAll && withoutAll.length > 0) {
        const type = {};
        let i = 0;

        for (const option of withoutAll) {
          type[`type[${i}]`] = option.value;
          i++;
        }

        Object.assign(body, type);
      }

      this.$axios
        .post("player/online/casino/bets/list", this.$formdata(body))
        .then((res) => {
          const period = this.$store.state.filters.casinoRange.value;
          if (period === "customRange") {
            const {
              to,
              from,
            } = this.$store.state.filters.casinoRange.customRange;
            this.searchedPeriod = `${from} ${this.$t(
              "until"
            ).toLowerCase()} ${to}`;
          } else {
            this.searchedPeriod = this.$store.state.filters.casinoRange.text
              ? this.$store.state.filters.casinoRange.text
              : period === "last24Hours"
              ? this.$t("casinoBetting.date.last24Hours")
              : "";
          }

          this.items = res.data.dados.map((game) => {
            const provider = game.identifier.split(":")[0];
            const gameTitle = game.identifier.split(":")[1];

            const src = encodeURI(
              `https://cdn.softswiss.net/i/s3/${provider}/${gameTitle}.png`.replace(
                /\s/g,
                ""
              )
            );

            return {
              ...game,
              src,
              provider,
              imageError: false,
              amountWithoutFormat: Number(game.amount),
              amount: this.getPortugueseMoney(Number(game.amount)),
            };
          });

          this.buildResume();
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cardClick(game) {
      const gameId = game.game_id;

      this.$request
        .post("/player/online/casino/game", { game_id: gameId, status: "1" })
        .then((res) => {
          const game = res.data.dados;

          game.game_id = gameId;
          game.src = encodeURI(
            `https://cdn.softswiss.net/i/s3/${
              game.identifier_game.split(":")[0]
            }/${game.identifier_game.split(":")[1]}.png`.replace(/\s/g, "")
          );
          game.categories = game.categories.split(",");
          game.categoryName = game.categories[0];
          game.providerImage = encodeURI(
            `https://cdn.softswiss.net/logos/providers/white/${
              game.identifier_game.split(":")[0]
            }.svg`.replace(/\s/g, "")
          );

          this.currentGameDialog = game;
          this.itemDialog = true;
        });
    },
    closeItemDialog() {
      this.currentGameDialog = {};
      this.itemDialog = false;
    },
    formatBrazilianDate(str) {
      str = str.split("/");
      return `${str[2]}-${str[1]}-${str[0]}`;
    },
    setDateIntervalAlert() {
      this.$store.commit("setNotification", {
        msg: this.$t("casinoBetting.setDateRange"),
        color: "warning",
      });

      this.$store.commit("setFeedbackProgress", false);
      this.$store.commit("setProgressLinear", false);
      this.$store.commit("setSave", false);
      this.$store.commit("DisabledSave", false);
    },
    getDateRange({ daysAgo }) {
      const body = {};

      let endDate = new Date();
      endDate.setTime(endDate.getTime() - endDate.getTimezoneOffset() * 60000);

      body.date_final = endDate.toISOString();

      let startDate = new Date(endDate.setDate(endDate.getDate() - daysAgo));

      body.date_start = startDate.toISOString();

      return body;
    },
    mapOperationIdToOperationName({ operation_id }) {
      const map = {
        101: this.$t("casinoBetting.bet"),
        114: this.$t("casinoBetting.bet"),
        102: this.$t("casinoBetting.prize"),
        115: this.$t("casinoBetting.prize"),
        108: this.$t("casinoBetting.betRefund"),
        116: this.$t("casinoBetting.betRefund"),
        109: this.$t("casinoBetting.prizeRefund"),
        117: this.$t("casinoBetting.prizeRefund"),
        113: this.$t("casinoBetting.freespinPrize"),
      };

      return map[operation_id];
    },
    buildResume(gameName = null) {
      const resume = {};

      resume.bets = 0;
      resume.prizes = 0;
      resume.betsRefund = 0;
      resume.prizesRefund = 0;
      resume.freespinPrize = 0;
      resume.profit = 0;

      this.items.forEach((item) => {
        if (gameName === null || item.name_game === gameName) {
          if (item.operation_id == 101 || item.operation_id == 114) {
            resume.bets = resume.bets + item.amountWithoutFormat;
          } else if (item.operation_id == 102 || item.operation_id == 115) {
            resume.prizes = resume.prizes + item.amountWithoutFormat;
          } else if (item.operation_id == 108 || item.operation_id == 116) {
            resume.betsRefund = resume.betsRefund + item.amountWithoutFormat;
          } else if (item.operation_id == 113) {
            resume.freespinPrize =
              resume.freespinPrize + item.amountWithoutFormat;
          } else {
            resume.prizesRefund =
              resume.prizesRefund + item.amountWithoutFormat;
          }
        }
      });

      resume.profit =
        resume.prizes +
        resume.freespinPrize -
        resume.prizesRefund -
        (resume.bets - resume.betsRefund);

      this.resume = resume;
    },
    getResumeItem({ key }) {
      const value = this.items
        .reduce((n, item) => n + Number(item[key]), 0)
        .toFixed(2);

      return {
        value: this.getPortugueseMoney(value),
      };
    },
    getPortugueseMoney(value) {
      return Number(value).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        style: "currency",
        currency: "BRL",
      });
    },
  },
};
</script>
<style>
.gridTable thead {
  display: none !important;
}

.gridTable tbody {
  background: #121212 !important;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(100%);
  transition: all 0.5s;
}

.list-move {
  transition: transform 0.5s;
}

.casino-item {
  background: none !important;
}
</style>
